import { useI18n } from '../../i18n/I18nProvider';
import { usePublicSettings } from '../settings/workspaceSettings';

/**
 * The small "Beta" tag shown beside the Grow logo while the product is in beta.
 * A super admin switches it off or renames it in Admin › Settings › General.
 */
export function BetaBadge({ className = '' }: { className?: string }) {
  const { t } = useI18n();
  const settings = usePublicSettings();
  if (!settings.beta_badge) return null;
  const label = settings.beta_badge_label.trim() || t('app.beta');
  return <span className={`beta-badge${className ? ` ${className}` : ''}`}>{label}</span>;
}
